/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../../../modules/auth/core/Auth'


const HelpCenter: React.FC = () => {

  useEffect(() => {


  });

  return (
    <div className='card shadow mb-5 mb-xl-10 bgi-no-repeat'
      style={{
        backgroundPosition: 'top right',
        backgroundSize: '100% auto',
        backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
        paddingRight: '0px'
      }}
    >

      <div className='card-body pt-9 pb-0'>
        <div className='flex-grow-1'>
          <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center mb-2'>
                <a className='text-black text-hover-primary fs-2 fw-bolder me-1' style={{ textTransform: 'capitalize' }}>
                  Help Center
                </a>
              </div>
            </div>
          </div>
          <div className='d-flex flex-wrap flex-stack'>
            <div className='d-flex flex-column flex-grow-1 pe-8'>
              <div className='d-flex flex-wrap'>
                {
                  useAuth().currentUser?.EscalationMatrix.Entities.map(
                    (esclation, index) => {
                      return (
                        <div key={`${index}`} className='border bg-light-primary border-primary border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-6 fw-bolder'> {esclation.Level1EmployeeName} - Account Manager</div>
                          </div>

                          <div className='fw-bold fs-8'>
                            <a
                              href={`tel:${esclation.Level1MobileNo}`}
                              className='d-flex align-items-center text-black text-hover-primary mb-2'
                            >
                              <KTSVG
                                path='/media/icons/duotune/communication/com005.svg'
                                className='svg-icon-4 me-1'
                              />
                              {esclation.Level1MobileNo}
                            </a>

                          </div>
                          <div className='fw-bold fs-8'>
                            <a
                              href={`mailto:${esclation.Level1Email}`}
                              className='d-flex align-items-center text-black text-hover-primary mb-2'
                            >
                              <KTSVG
                                path='/media/icons/duotune/communication/com011.svg'
                                className='svg-icon-4 me-1'
                              />
                              {esclation.Level1Email}
                            </a>
                          </div>
                        </div>
                      )
                    }
                  )

                }

                <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 d-none d-lg-block'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-6 fw-bolder'> Tollfree Helpline (9AM - 9PM)</div>
                  </div>
                  <div className='fw-bold fs-8'>
                    <a
                      href={`tel:18001034569`}
                      className='d-flex align-items-center text-black text-hover-primary mb-2'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com005.svg'
                        className='svg-icon-4 me-1'
                      />
                      1800-1034-569
                    </a>

                  </div>
                  <div className='fw-bold fs-8'>
                    <a
                      href={`mailto:servicehelpdesk@futurisk.in`}
                      className='d-flex align-items-center text-black text-hover-primary mb-2'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com011.svg'
                        className='svg-icon-4 me-1'
                      />
                      servicehelpdesk@futurisk.in
                    </a>
                  </div>
                </div>

                <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 d-none d-lg-block'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-6 fw-bolder'> WhatsApp Chat Bot </div>
                  </div>
                  <div className='fw-bold fs-8'>
                    <a
                      href={`https://wa.me/919150581818`}
                      className='d-flex align-items-center text-black text-hover-primary mb-2'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com005.svg'
                        className='svg-icon-4 me-1'
                      />
                    +919150581818
                    </a>

                  </div>
                  <div className='fw-bold fs-8'>
                    <div
                      
                      className='d-flex align-items-center text-black text-hover-primary mb-2'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com011.svg'
                        className='svg-icon-4 me-1'
                      />
                      Ping Hi in WhatsApp to start chat
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

          
        </div>

        
      </div>
    </div>
  )


}

export { HelpCenter }
